import { IconBusinessplan, IconReceipt, IconFileInvoice, IconCurrencyDollar, IconWallet } from "@tabler/icons";

const icons = { IconBusinessplan, IconReceipt, IconFileInvoice, IconCurrencyDollar, IconWallet };

const payment = {
  id: "payment",
  title: "Payment",
  type: "group",
  children: [
    {
      id: "default",
      title: "Payment",
      type: "collapse",
      url: "/payment",
      icon: icons.IconBusinessplan,
      breadcrumbs: true,
      children: [
        {
          id: "balance",
          title: "Balance",
          type: "item",
          icon: icons.IconWallet,
          breadcrumbs: "true",
          url: "/payment/balance",
        },
        {
          id: "bills",
          title: "Bills",
          type: "item",
          icon: icons.IconFileInvoice,
          breadcrumbs: "true",
          url: "/payment/bills",
        },
        {
          id: "receipts",
          title: "Receipts",
          type: "item",
          icon: icons.IconReceipt,
          breadcrumbs: "true",
          url: "/payment/receipts",
        },
        {
          id: "currency",
          title: "Currency",
          type: "item",
          icon: icons.IconCurrencyDollar,
          breadcrumbs: "true",
          url: "/payment/currency",
        },
      ],
    },
  ],
};

export default payment;
